<template>
  <div class="activationCourse">
      <div class="actCourseContent">
         <h2 class="actTitle">绑定课程卡</h2>
          <div class="from_content">
              <van-form>
                  <van-field
                    v-model.trim="cardNum"
                    type="input"
                    clearable
                    label="卡号"
                    @change="change"
                    placeholder="请输入课程卡号"
                  />
                  <van-field
                    class="codeField"
                    v-model.trim="passwordNum"
                    type="input"
                    clearable
                    label="密码"
                    placeholder="请输入课程卡密码"
                  />
                  <div class="activationBtn"><van-button type="primary" size="large"  @click="onClickActive">立即激活</van-button></div>
              </van-form>
          </div>
      </div>
      <div class="popupTip">
        <van-popup v-model="show">
           <img @click="closePopup" class="closeImg" src="../../assets/img/productDetail/close01.png" alt="">
          <div class="popupMain">
            <img src="../../assets/img/productDetail/ok01.png" alt="">
            <h2>激活成功</h2>
            <div @click="toMyCourse">{{courseType?'填写地址':'查看我的课程'}}</div>
          </div>
        </van-popup>
      </div>

      <Loading ref="load"/>
  </div>
</template>

<script>
import Loading from '../../components/loading/loading.vue';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      cardNum: '', // 卡号
      passwordNum: '', // 密码
      show: false,
      courseType: null, // 判断是否有地址

    };
  },

  computed: {

  },
  mounted() {
  },

  methods: {
    // 关闭弹窗
    closePopup() {
      this.show = false;
      // 清空input值
      this.cardNum = '';
      this.passwordNum = '';
    },
    // 激活课程
    async onClickActive() {
      if (this.cardNum === undefined || this.cardNum === '') {
        this.$toast('请输入课程卡号');
      } else if (this.passwordNum === undefined || this.passwordNum === '') {
        this.$toast('请输入课程卡密码');
      } else {
        //
      }
    },

    toMyCourse() {
      this.show = false;
      // 清空input值
      this.cardNum = '';
      this.passwordNum = '';
      if (this.courseType) {
        // 填写地址
        const routeUrl = this.$router.resolve({
          path: '/vip/order',
        });
        window.location.href = routeUrl.resolved.fullPath;
      } else {
        // 我的课程
        const routeUrl = this.$router.resolve({
          path: '/main',
        });
        window.location.href = routeUrl.resolved.fullPath;
      }
    },

  },
};

</script>

<style lang="scss" scoped>
.activationCourse{
  width: 100%;
  min-height: 100vh;
  background: #fff;
  .actCourseContent{
    width: 83%;
    margin: 0 auto;
    .actTitle{
      margin-top:48px;
      color: #333;
      font-weight: 600;
      font-size: 40px;
      line-height: 56px;
    }
    .from_content{
      margin-top:64px;
      ::v-deep .van-form{
        .van-cell{
          padding-right: 0;
          padding-left: 0;
          &::after {
            border-bottom: none;
          }
          .van-field__label{
            width:10%;
            margin-right: 22px;
            line-height: 28px;
            span{
              color: #333;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
            }
          }
          .van-field__body{
            padding-bottom: 4px;
            border-bottom: 1px solid #eee;
             .van-field__control{
                height: 28px;
                color: #303030;
                font-size: 14px;
                line-height: 28px;
              }
          }
        }
        .van-field__button{
          box-sizing: border-box;
          .van-button--primary{
            height: 28px;
            color: #FF6C02;
            font-weight: 400;
            font-size: 12px;
            background: #fff;
            border: 1px solid #FF6C02;
            border-radius: 4px;
          }

        }
        .codeField {
          margin-top:15px;
        }

      }
      .activationBtn{
        margin-top:100px;
        text-align: center;
        ::v-deep .van-button--large{
          width: 100%;
          height: 44px;
          letter-spacing: 1PX;
          background: rgba(255,108,2,1);
          border:none;
          border-radius: .12rem
        }

    }

    }
  }
  .popupTip{
    ::v-deep .van-popup{
      box-sizing: border-box;
      width: 75%;
      padding-top:12px;
      padding-bottom: 48px;
      border-radius: 8px;
      .closeImg{
        display: block;
        float: right;
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
      .popupMain{
        padding:38px 47px 0 47px;
        text-align: center;
        img{
          width: 48px;
          height: 48px;

        }
        h2{
          padding:22px 0 24px 0;
          color: #333;
          font-weight: 600;
          font-size: 16px;
        }
        div{
          width: 100%;
          height: 40px;
          color: #fff;
          font-weight: 600;
          font-size: 16px;
          line-height: 40px;
          text-align: center;
          background: #FF6C02;
          border-radius: 25px;

        }

      }

    }
  }
}

</style>
